import './contacts.scss';

import {generateMarkers} from "./map";

(function($){

  $(function(){

    if($('#map').length){
      let el = $('#map');
      let data = {
        lat: el.data('latitude'),
        lng: el.data('longitude'),
        address: el.data('address'),
        title: el.data('title'),
        center: [el.data('latitude'), el.data('longitude')],
        zoom: 12,
      };
      new generateMarkers(data, 'map', data.center, data.zoom);
    }

  });

})(jQuery);
